﻿import { fromEvent, map, merge, tap } from 'rxjs';

const searchResultContent = document.querySelector('[data-page-layout-container]');
const mapButtonToggle = document.querySelector('[data-map-button-toggle]');
const listButtonToggle = document.querySelector('[data-list-button-toggle]');
/**
 * This function adds specific classes to the container element to set it to a map view
 * layout.
 */
const setMapView = () => {
  searchResultContent.classList.add('nhs-c-wrapper--map-view', 'nhs-mq-wrapper--map-view-medium');
};

/**
 * This function removes specific classes from a container element and dispatches a custom
 * event to toggle the list view.
 */
const setListView = () => {
  searchResultContent.classList.remove('nhs-c-wrapper--map-view', 'nhs-mq-wrapper--map-view-medium');

  const event = new CustomEvent('listViewToggled');
  document.body.dispatchEvent(event);
};

const sortButton = document.querySelector('#sort-select');
const sortButtons = document.querySelectorAll('[data-sort-element]');

const toggleSortVisibility = (button) => {
  const hide = button.dataset.state === 'map';
  const displayValue = hide ? 'none' : 'block';

  sortButton.style.display = displayValue;
  sortButtons.forEach((btn) => {
    btn.style.display = displayValue;
  });
};

/**
 * Hides the map view toggle button.
 */
const hideMapButton = () => mapButtonToggle.setAttribute('hidden', '');

/**
 * Hides the list view toggle button.
 */
const hideListButton = () => listButtonToggle.setAttribute('hidden', '');

/**
 * Shows the map view toggle button.
 */
const showMapButton = () => mapButtonToggle.removeAttribute('hidden');

/**
 * Shows the list view toggle button.
 */
const showListButton = () => listButtonToggle.removeAttribute('hidden');

/**
 * An observable stream that listens for click events on the `listButtonToggle` element.
 * When a click event occurs, it maps the event to the current target
 * element, then sequentially performs the following actions using the `tap` operator:
 * 1. `hideListButton`: Hides the list view toggle button.
 * 2. `showMapButton`: Shows the map view toggle button.
 * 3. `setListView`: Removes specific classes from a container element and dispatches a custom event to
 * toggle the list view.
 * 4. `toggleSortVisibility`: Toggles the visibility of sort buttons based on the button's dataset
 * state.
 */
const onListButtonClick$ = fromEvent(listButtonToggle, 'click').pipe(
  map((event) => event.currentTarget),
  tap(hideListButton),
  tap(showMapButton),
  tap(setListView),
  tap(toggleSortVisibility)
);

/**
 * An observable stream that listens for click events on the `mapButtonToggle` element.
 * When a click event occurs, it maps the event to the current target
 * element, then sequentially performs the following actions using the `tap` operator:
 * 1. `hideMapButton`: Hides the map view toggle button.
 * 2. `showListButton`: Shows the list view toggle button.
 * 3. `setMapView`: Sets specific classes from a container element.
 * 4. `toggleSortVisibility`: Toggles the visibility of sort buttons based on the button's dataset
 * state.
 */
const onMapButtonClick$ = fromEvent(mapButtonToggle, 'click').pipe(
  map((event) => event.currentTarget),
  tap(hideMapButton),
  tap(showListButton),
  tap(setMapView),
  tap(toggleSortVisibility)
);

merge(onListButtonClick$, onMapButtonClick$).subscribe();
